<template>
    <a-layout
      :style="{
        minHeight: '100vh'
      }"
    >
        <a-layout-header
            class="app-layout-header primary-blue-bg"
            :style="{
                position: 'fixed',
                top: 0,
                zIndex: 100,
                width: '100%',
            }"
        >
            <AppHeaderComponent />
        </a-layout-header>
        <a-layout-content
            class="app-layout-content"
            :style="{
                marginTop: '75px',
                height: 'calc(100vh - 75px - 70px)',
                marginBottom: '70px',
                overflowY: 'scroll'
            }"
        >   
            <FadeTransition>
                <router-view></router-view>
            </FadeTransition>
        </a-layout-content>
        <a-layout-footer
            :style="{
                borderTop: '1px solid #e8e8e8',
                position: 'fixed',
                zIndex: 100,
                bottom: 0,
                width: '100%',
            }"
        >
            <AppFooterComponent />
            <!-- <MessagerComponent /> -->
        </a-layout-footer>
    </a-layout>
</template>

<script>
import LoginCardComponent from '@/components/login/LoginCardComponent.vue';
import AppHeaderComponent from '@/components/app/header_components/AppHeaderComponent.vue';
import AppFooterComponent from '@/components/app/footer_components/AppFooterComponent.vue';
import FadeTransition from '@/transitions/FadeTransition.vue';
import MessagerComponent from '@/components/app/messaging_components/MessagerComponent.vue';

export default {

    components: {
        LoginCardComponent,
        AppHeaderComponent,
        AppFooterComponent,
        FadeTransition,
        MessagerComponent
    },

    data() {
        return {
            printscreenJammerRef: null
        }
    },

    created() {
        window.addEventListener('keyup', this.printScreenHandler);
        const realId = 5712;
        this.$simbIHC.rHS = realId;
    },


    methods: {
        printScreenHandler(e) {
            if (e.keyCode == 44) {
                console.log('PRINTSCREEN PRESSED');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .primary-blue-bg {
        background-color: $primary-blue;
    }
    .app-layout-header {
        padding: 0;
        @include sm {
            padding: 0px 50px;
        }
    }
    .app-layout-content {
        padding:0px 15px;
        @include sm {
            padding: 0px 50px;
        }
    }

</style>
